import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { checkAuthStatus } from './redux/slices/authSlice';
import { setStoreReference } from './api';
import HomePageBG from './assets/HomepageBG.jpg';
import store from './redux/store';
import { Navbar } from './components/Navbar';

import { Footer } from './components/Footer';

import { Login } from './pages/auth/Login';
import { ErrorPage } from './pages/public/ErrorPage';
import { HomePage } from './pages/public/HomePage';
import { AboutUsPage } from './pages/public/AboutUsPage';
import { EventPage } from './pages/public/EventPage';
import { ResourcesPage } from './pages/public/ResourcesPage';
import { PrivacyPage } from './pages/public/PrivacyPage';
import { RCDPage } from './pages/public/RCDPage';
import { AchievementsPage } from './pages/public/AchievementsPage';
import { ContactUsPage } from './pages/public/ContactUsPage';
import { FarmsharePage } from './pages/farmshare/FarmsharePage';
import { FarmsharePage as FarmsharePageInProgress } from './pages/farmshare/FarmsharePageInProgress';
import { UserList } from './pages/admin/UserList';
import { ReservationList } from './pages/admin/ReservationList';
import { EquipmentListPage } from './pages/admin/EquipmentListPage';
import { DetailEquipmentPage } from './pages/farmshare/DetailEquipmentPage';
import { UserProfilePage } from './pages/user/UserProfilePage';
import { UserReservations } from './pages/farmshare/UserReservations';
import { ProtectedRoute } from './components/ProtectedRoute';

import { PublicRoute } from './components/PublicRoute';

setStoreReference(store);

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuthStatus());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/login"
          element={
            // Dont go here if logged in.
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route path="/events" element={<EventPage />} />
        {/*         <Route
          path="/farmshare"
          element={
            <ProtectedRoute>
              <FarmsharePage />
            </ProtectedRoute>
          }
        /> */}
        <Route path="/farmshare" element={<FarmsharePage />} />
        <Route
          path="/farmshare/:equipmentId"
          element={
            <ProtectedRoute>
              <DetailEquipmentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/farmshare/profile"
          element={
            <ProtectedRoute>
              <UserProfilePage />
            </ProtectedRoute>
          }
        />
        <Route path="/farmshareIP" element={<FarmsharePageInProgress />} />
        <Route path="/achievements" element={<AchievementsPage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/rcd" element={<RCDPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route
          path="/userlist"
          element={
            <ProtectedRoute requireAdmin={true}>
              <UserList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reservationlist"
          element={
            <ProtectedRoute requireAdmin={true}>
              <ReservationList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/myreservations"
          element={
            <ProtectedRoute>
              <UserReservations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/equipmentlist"
          element={
            <ProtectedRoute requireAdmin={true}>
              <EquipmentListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <>
              <Navbar src={HomePageBG} pageName={``} />
              <ErrorPage />
            </>
          }
        />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
